export const IconPause = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <mask
        id="IconPause_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconPause_svg__a)">
        <path d="M16 19q-.825 0-1.412-.587A1.93 1.93 0 0 1 14 17V7q0-.824.588-1.412A1.93 1.93 0 0 1 16 5q.824 0 1.413.588Q18 6.175 18 7v10q0 .824-.587 1.413A1.93 1.93 0 0 1 16 19m-8 0q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 17V7q0-.824.588-1.412A1.93 1.93 0 0 1 8 5q.825 0 1.412.588Q10 6.175 10 7v10q0 .824-.588 1.413A1.93 1.93 0 0 1 8 19" />
      </g>
    </svg>
  );
};
